<template>
  <div class="qrcode">
    <!-- 返回按钮 -->
    <div class="back-btn" @click="back">
      <van-icon name="arrow-left" size="24" color="#fff" />
    </div>
    <video
        ref="video"
        id="video"
        class="scan-video"
        :class="{ mirrored: scanTextData.isMirrored }"
        autoplay
        playsinline
        webkit-playsinline
        @click="enableVibration"
        @touchstart="enableVibration"
    ></video>
    <!-- 二维码中心圆点 - 类似微信 -->
    <div
        v-if="scanTextData.qrCodePosition"
        class="qr-code-dot"
        :style="{
          left: scanTextData.qrCodePosition.x + 'px',
          top: scanTextData.qrCodePosition.y + 'px'
        }">
      <div class="dot-inner"></div>
    </div>
    <div class="scan-img">
      <div class="scan-frame" :class="{ 'scan-success': scanTextData.scanSuccess }">
        <span class="left-t"></span>
        <span class="right-t"></span>
        <span class="left-b"></span>
        <span class="right-b"></span>
        <!-- 扫描线：只在未成功时显示 -->
        <span
            class="cross-line"
            v-show="!scanTextData.scanSuccess && scanTextData.scanning"
            :style="{ animationPlayState: scanTextData.scanSuccess ? 'paused' : 'running' }"
        ></span>
      </div>
    </div>
    <div class="scan-tip">
      {{ scanTextData.tipMsg  }}
    </div>
    <div class="scan-btn">
      <img @click="switchCamera" src="/static/images/camera.png" alt="切换摄像头"> <!-- 添加切换摄像头按钮 -->
    </div>
  </div>
</template>



<script>
import { BrowserMultiFormatReader } from "@zxing/library";
import { Toast } from "vant";
import { mapMutations } from 'vuex';

export default {
  name: "scanCodePage",
  data() {
    return {
      scanTextData: {
        loadingShow: false,
        codeReader: null, // 延迟初始化，避免在data中创建
        vin: null,
        tipMsg: '', // 初始值，mounted后设置国际化
        tipShow: false,
        showScanBox: false,
        showScanBoxInfo: false,
        videoInputDevices: [],
        currentDeviceId: null,
        isUsingBackCamera: true, // 默认使用后置摄像头
        isMirrored: false, // 用于处理前置摄像头的镜像效果
        scanSuccess: false, // 扫码成功标志
        qrCodePosition: null, // 二维码位置信息 {x, y, width, height}
        scanning: true, // 是否正在扫描
        userInteracted: false, // 用户是否已经交互过（用于启用震动）
        needPermission: false, // 是否需要权限提示
      },

      scanText: "",
      scanDebounceTimer: null, // 防抖定时器

    };
  },
  mounted() {
    // 设置国际化提示
    this.scanTextData.tipMsg = this.$t('append_field.qrcode_placeholder')

    // 延迟调用，确保DOM已渲染
    this.$nextTick(() => {
      const video = this.$refs.video
      if (!video) {
        console.error('视频元素未找到！')
        return
      }

      // 尝试直接启动扫码（如果浏览器允许）
      this.openScan().catch(() => {
        // 如果失败，可能是因为需要用户交互，显示权限提示
        this.scanTextData.needPermission = true
        this.scanTextData.tipMsg = this.$t('append_field.camera_unauthorized')
      })
    })
  },
  beforeDestroy() {
    this.cancelScan()
  },
  methods: {
    ...mapMutations(['setScanResult']),
    back() {
      // 先清理资源再返回
      const video = this.$refs.video
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => {
          track.stop()
        })
        video.srcObject = null
      }
      if (this.scanTextData.codeReader) {
        try {
          this.scanTextData.codeReader.reset()
        } catch (e) {
          console.warn('重置扫码读取器失败:', e)
        }
      }
      // 关闭子组件
      this.$emit('scan-cancel')
    },
    cancelScan() {
      // 清除防抖定时器
      if (this.scanDebounceTimer) {
        clearTimeout(this.scanDebounceTimer)
        this.scanDebounceTimer = null
      }

      // 立即停止扫码
      this.stopScanning()

      const video = this.$refs.video

      // 停止视频流
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => {
          track.stop()
        })
        video.srcObject = null
      }

      // 重置扫码读取器
      if (this.scanTextData.codeReader) {
        try {
          this.scanTextData.codeReader.reset()
        } catch (e) {
          console.warn('重置扫码读取器失败:', e)
        }
      }

      // 重置状态
      this.scanTextData.scanning = false
      this.scanTextData.scanSuccess = false
      this.scanTextData.qrCodePosition = null

      // 立即触发 scan-complete 事件，让父组件关闭扫码组件
      this.$emit('scan-complete')
    },
    // 请求摄像头权限（首次使用需要）
    async requestCameraPermission() {
      try {
        // 先请求摄像头权限（使用facingMode: 'environment'指定后置摄像头）
        // 这样可以确保浏览器获取到完整的设备标签信息
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: 'environment' } // 优先使用后置摄像头
          }
        })

        // 权限已授予

        this.scanTextData.needPermission = false

        // 立即停止这个临时流，我们只是为了获取权限和触发设备列表更新
        stream.getTracks().forEach(track => track.stop())

        // 等待一小段时间，确保设备列表已更新
        await new Promise(resolve => setTimeout(resolve, 200))

        return true
      } catch (error) {
        console.warn('请求摄像头权限失败:', error)
        // 如果使用environment失败，尝试通用请求
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true })

          this.scanTextData.needPermission = false
          stream.getTracks().forEach(track => track.stop())
          await new Promise(resolve => setTimeout(resolve, 200))
          return true
        } catch (e) {
          console.error('请求摄像头权限完全失败:', e)
          this.scanTextData.needPermission = true

          return false
        }
      }
    },


    // 启动扫码流程
    async startScanning() {
      try {
        // 初始化扫码读取器
        this.scanTextData.codeReader = new BrowserMultiFormatReader()

        // 获取摄像头设备列表（现在应该包含完整的标签信息）
        this.scanTextData.videoInputDevices = await this.scanTextData.codeReader.getVideoInputDevices()

        if (!this.scanTextData.videoInputDevices || this.scanTextData.videoInputDevices.length === 0) {
          this.scanTextData.tipMsg = this.$t('append_field.camera_not_found')
          return
        }

        console.log('找到摄像头设备:', this.scanTextData.videoInputDevices.length, '个')


        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
        let backCamera
        let selectedDeviceId = null

        // 检查设备标签是否完整（某些浏览器首次使用时标签可能为空）
        const hasLabels = this.scanTextData.videoInputDevices.some(device => device.label && device.label.trim() !== '')

        if (hasLabels) {
          // 如果设备有标签，通过标签查找后置摄像头
          backCamera = this.scanTextData.videoInputDevices.find(device => {
            const label = (device.label || '').toLowerCase()
            return label.includes("back") ||
                label.includes("rear") ||
                label.includes("environment") ||
                label.includes("后置") ||
                label.includes("后")
          })

          if (backCamera) {
            // 如果有多个后置摄像头，选择最合适的
            if (this.scanTextData.videoInputDevices.length > 3) {
              // 尝试找到主后置摄像头
              const mainBackCamera = this.scanTextData.videoInputDevices.find(device => {
                const label = (device.label || '').toLowerCase()
                return (label.includes("back") || label.includes("rear")) &&
                    (label.includes("main") || label.includes("primary") || label.includes("主"))
              })

              if (mainBackCamera) {
                selectedDeviceId = mainBackCamera.deviceId
              } else if (this.scanTextData.videoInputDevices.length > 5) {
                selectedDeviceId = this.scanTextData.videoInputDevices[5].deviceId
              } else {
                selectedDeviceId = backCamera.deviceId
              }
            } else {
              selectedDeviceId = backCamera.deviceId
            }
          }
        }

        // 如果没有通过标签找到，使用设备特定的默认策略
        if (!selectedDeviceId) {
          if (isIOS) {
            // iOS设备通常有两个摄像头，索引1是后置
            if (this.scanTextData.videoInputDevices.length > 1) {
              selectedDeviceId = this.scanTextData.videoInputDevices[1].deviceId
            } else {
              selectedDeviceId = this.scanTextData.videoInputDevices[0].deviceId
            }
          } else {
            // Android设备：根据设备数量选择
            if (this.scanTextData.videoInputDevices.length > 3) {
              selectedDeviceId = this.scanTextData.videoInputDevices[3].deviceId
            } else if (this.scanTextData.videoInputDevices.length > 1) {
              // 如果只有2个设备，第一个通常是后置
              selectedDeviceId = this.scanTextData.videoInputDevices[0].deviceId
            } else {
              selectedDeviceId = this.scanTextData.videoInputDevices[0].deviceId
            }
          }
        }

        if (!selectedDeviceId) {
          this.scanTextData.tipMsg = this.$t('append_field.camera_select_failed')
          return
        }

        this.scanTextData.currentDeviceId = selectedDeviceId

        // 标记当前使用的是后置摄像头
        if (backCamera || (!isIOS && this.scanTextData.videoInputDevices.length > 1)) {
          this.scanTextData.isUsingBackCamera = true
          this.scanTextData.isMirrored = false
        }

        this.decodeFromInputVideoFunc(this.scanTextData.currentDeviceId)
      } catch (err) {
        console.error('启动扫码失败:', err)
        this.scanTextData.needPermission = true
        this.scanTextData.tipMsg = this.$t('append_field.camera_start_failed')
      }
    },

    async openScan() {
      try {
        // 先请求摄像头权限，确保能够获取完整的设备列表和标签
        this.scanTextData.tipMsg = this.$t('append_field.camera_permission_requesting')
        const hasPermission = await this.requestCameraPermission()

        if (!hasPermission) {
          // 权限请求失败，可能是因为需要用户交互
          // 显示权限提示，让用户点击
          this.scanTextData.needPermission = true
          this.scanTextData.tipMsg = this.$t('append_field.camera_click_to_start')
          return
        }

        // 权限获取成功，启动扫码
        await this.startScanning()
      } catch (err) {
        this.scanTextData.tipShow = false
        console.error('打开扫码失败:', err)

        // 详细的错误处理
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          this.scanTextData.needPermission = true
          this.scanTextData.tipMsg = this.$t('append_field.camera_permission_denied')
        } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
          this.scanTextData.tipMsg = this.$t('append_field.camera_device_not_found')
        } else {
          this.scanTextData.needPermission = true
          this.scanTextData.tipMsg = this.$t('append_field.camera_init_failed')
        }
      }
    },
    decodeFromInputVideoFunc(deviceId) {
      const video = this.$refs.video

      if (!video) {
        return
      }

      if (!this.scanTextData.codeReader) {
        this.scanTextData.tipMsg = this.$t('append_field.scanner_not_initialized')
        return
      }

      // 如果视频已经在播放，先停止当前视频流
      if (video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop())
        video.srcObject = null
      }

      // 重置扫码读取器
      try {
        this.scanTextData.codeReader.reset()
      } catch (e) {
        console.warn('重置扫码读取器失败:', e)
      }

      // 设置提示信息
      this.scanTextData.tipMsg = this.$t('append_field.qrcode_placeholder')

      try {
        // 开始解码
        // BrowserMultiFormatReader 会自动优化性能和处理视频流
        this.scanTextData.codeReader.decodeFromVideoDevice(
            deviceId,
            video,
            (result) => {
              // 如果已经扫描成功或扫码已停止，立即返回，不再处理
              if (!this.scanTextData.scanning || this.scanTextData.scanSuccess) {
                return
              }

              if (result) {

                if (result.text) {
                  // 如果已经扫描成功，不再处理新的结果
                  if (this.scanTextData.scanSuccess) {
                    return
                  }
                  
                  // 清除防抖定时器
                  if (this.scanDebounceTimer) {
                    clearTimeout(this.scanDebounceTimer)
                  }

                  // 设置防抖，100ms内只处理一次
                  this.scanDebounceTimer = setTimeout(() => {
                    // 再次检查状态，防止在防抖期间扫码已停止
                    if (this.scanTextData.scanning && !this.scanTextData.scanSuccess) {
                      this.handleScanResult(result, video)
                    }
                  }, 100)
                }
              }
            })
      } catch (error) {
        console.error('启动扫码失败:', error)

        this.scanTextData.tipMsg = this.$t('append_field.scan_start_failed')
      }
    },
    // 验证二维码是否有效
    validateQRCode(data) {
      if (!data || typeof data !== 'object') {
        return {
          valid: false,
          message: this.$t('append_field.qrcode_format_error')
        }
      }

      if (data.channel!=='') {
        return {
          valid: true,
          message: this.$t('append_field.qrcode_verify_success')
        }
      }

      return {
        valid: false,
        message: this.$t('append_field.qrcode_verify_failed')
      }


    },
    // 启用震动（需要在用户交互后调用）
    enableVibration() {
      if (!this.scanTextData.userInteracted) {
        this.scanTextData.userInteracted = true
        // 测试震动是否可用（短震动）
        this.vibrate(10)

      }
    },

    // 震动反馈
    vibrate(pattern = [50, 30, 50]) {
      // 检查是否支持震动API
      if (!('vibrate' in navigator)) {
        return false
      }

      // 某些浏览器需要用户交互后才能震动
      // 如果用户还没有交互，先标记用户已交互（扫码本身就是用户交互）
      if (!this.scanTextData.userInteracted) {
        this.scanTextData.userInteracted = true
      }

      try {
        // 调用震动API
        const result = navigator.vibrate(pattern)
        if (result === false) {
          // 如果被拒绝，尝试简单的单次震动
          try {
            navigator.vibrate(50)

            return true
          } catch (e) {

            return false
          }
        } else {

          return true
        }
      } catch (e) {
        console.error('震动功能出错:', e)
        // 尝试降级到简单震动
        try {
          if (typeof pattern === 'number') {
            navigator.vibrate(pattern)
          } else if (Array.isArray(pattern) && pattern.length > 0) {
            navigator.vibrate(pattern[0])
          }
          return true
        } catch (e2) {

          return false
        }
      }
    },

    // 计算二维码中心位置（用于显示圆点）
    calculateQRCodePosition(result, video) {
      if (!result.resultPoints || result.resultPoints.length < 4) {
        return null
      }

      const videoRect = video.getBoundingClientRect()
      const videoWidth = video.videoWidth || videoRect.width
      const videoHeight = video.videoHeight || videoRect.height

      // 计算视频的实际显示尺寸和原始尺寸的比例
      const scaleX = videoRect.width / videoWidth
      const scaleY = videoRect.height / videoHeight

      // 获取二维码的四个角点，计算中心点
      const points = result.resultPoints
      let sumX = 0, sumY = 0

      points.forEach(point => {
        sumX += point.x * scaleX
        sumY += point.y * scaleY
      })

      // 计算中心点
      const centerX = sumX / points.length + videoRect.left
      const centerY = sumY / points.length + videoRect.top

      return {
        x: centerX,
        y: centerY
      }
    },

    // 停止扫描
    stopScanning() {
      this.scanTextData.scanning = false
      if (this.scanTextData.codeReader) {
        try {
          this.scanTextData.codeReader.reset()
        } catch (e) {
          console.warn('停止扫描失败:', e)
        }
      }
    },

    extractJsonParam(text, key) {
      if (!text || !key) return null
      const markers = [`?${key}=`, `&${key}=`]
      let substring = ''
      for (const marker of markers) {
        const idx = text.indexOf(marker)
        if (idx !== -1) {
          substring = text.slice(idx + marker.length)
          break
        }
      }
      if (!substring) {
        return null
      }
      const braceIndex = substring.indexOf('{')
      if (braceIndex !== -1) {
        substring = substring.slice(braceIndex)
      }
      const extracted = this.extractJsonString(substring)
      return extracted || substring
    },

    extractJsonString(str) {
      if (!str) return null
      let depth = 0
      let inString = false
      let prevChar = ''
      for (let i = 0; i < str.length; i++) {
        const char = str[i]
        if (char === '"' && prevChar !== '\\') {
          inString = !inString
        }
        if (!inString) {
          if (char === '{') {
            depth += 1
          } else if (char === '}') {
            depth -= 1
            if (depth === 0) {
              return str.slice(0, i + 1)
            }
          }
        }
        prevChar = char
      }
      return null
    },

    decodeJsonParam(param) {
      if (!param) return ''
      const sanitized = param.replace(/%(?![0-9A-Fa-f]{2})/g, '%25')
      try {
        return decodeURIComponent(sanitized)
      } catch (e) {
        console.warn('decodeJsonParam failed, fallback to original value', e)
        return param
      }
    },

    normalizeBase64(value) {
      if (typeof value !== 'string') return value
      return value.replace(/\s+/g, '+')
    },

    // 处理扫码结果
    handleScanResult(result, video) {
      const text = result.text
      try {
        let dataJson = null

        // 检查是否是URL格式（包含p参数）
        const rawParam = this.extractJsonParam(text, 'p')
        if (rawParam) {
          const decodedData = this.decodeJsonParam(rawParam)
          const dataObj = JSON.parse(decodedData)
          if (dataObj && typeof dataObj.data === 'string') {
            dataObj.data = this.normalizeBase64(dataObj.data)
          }
          dataJson = dataObj
          this.scanText = dataObj
        } else {
          // 如果不是URL格式，提示错误并停止扫描
          this.stopScanning()
          // 立即停止扫描动画
          this.scanTextData.scanSuccess = true

          this.scanTextData.tipMsg = this.$t('append_field.scan_content_unrecognized')

          // 延迟后退出界面
          setTimeout(() => {
            this.$emit('scan-cancel')
          }, 1500)
          return
        }

        // 验证二维码是否有效
        if (this.scanText) {
          const validation = this.validateQRCode(dataJson)

          // 无论验证是否通过，都先停止扫描和动画
          this.stopScanning()
          // 立即设置成功状态，隐藏扫描线动画
          this.scanTextData.scanSuccess = true

          if (!validation.valid) {

            this.scanTextData.tipMsg = validation.message || this.$t('append_field.scan_content_unrecognized')

            // 延迟后退出界面
            setTimeout(() => {
              this.back()
            }, 1500)
            return
          }

          // 验证通过
          // 计算并显示二维码中心位置（圆点）
          const qrPosition = this.calculateQRCodePosition(result, video)
          if (qrPosition) {
            this.scanTextData.qrCodePosition = qrPosition
          }

          // 震动反馈 - 确保在用户交互后调用
          this.$nextTick(() => {
            // 使用多种震动模式尝试
            const vibrateSuccess = this.vibrate([50, 30, 50]) // 震动-暂停-震动，类似微信

            if (!vibrateSuccess) {
              // 如果失败，尝试简单震动
              setTimeout(() => {
                this.vibrate(100)
              }, 50)
            }
          })

          // 更新提示信息
          this.scanTextData.tipMsg = this.$t('append_field.scan_success') || '识别成功'

          // 立即停止扫码读取器，防止继续扫描
          this.stopScanning()
          

          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => {
              track.stop()
            })
            video.srcObject = null
          }

          // 将扫码数据存储到 Vuex store
          this.setScanResult(dataJson)

          // 立即关闭扫码组件，不再延迟
          // 圆点效果已经显示，可以立即关闭
          this.$nextTick(() => {
            this.cancelScan()
          })
        } else {
          // 数据解析失败，停止扫描并退出
          this.stopScanning()
          // 立即停止扫描动画
          this.scanTextData.scanSuccess = true

          this.scanTextData.tipMsg = this.$t('append_field.scan_content_unrecognized')

          // 延迟后退出界面
          setTimeout(() => {
            this.back()
          }, 1500)
        }
      } catch (error) {
        console.error(error,'解析错误')
        // 处理出错，停止扫描并退出
        this.stopScanning()
        // 立即停止扫描动画
        this.scanTextData.scanSuccess = true
        this.scanTextData.tipMsg = this.$t('append_field.process_failed')

        // 延迟后退出界面
        setTimeout(() => {
          this.back()
        }, 1500)
      }
    },

    async switchCamera() {
      const videoInputDevices = this.scanTextData.videoInputDevices
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS) {
        // iOS设备通常有两个摄像头
        if (videoInputDevices.length < 2) {
          Toast(this.$t('append_field.no_other_camera'))
          return
        }

        // 获取当前摄像头的索引
        const currentIndex = videoInputDevices.findIndex(device => device.deviceId === this.scanTextData.currentDeviceId)

        if (currentIndex === -1) {
          Toast(this.$t('append_field.camera_not_found_current'))
          return
        }

        // 计算新摄像头的索引
        const newIndex = (currentIndex === 0) ? 1 : 0

        if (!videoInputDevices[newIndex]) {
          Toast(this.$t('append_field.camera_switch_failed'))
          return
        }

        // 切换摄像头
        this.scanTextData.currentDeviceId = videoInputDevices[newIndex].deviceId
        this.scanTextData.isUsingBackCamera = (newIndex === 1)
        this.scanTextData.isMirrored = (newIndex === 0) // 前置摄像头镜像，后置摄像头不镜像

        // 提示当前切换到的摄像头
        await this.decodeFromInputVideoFunc(this.scanTextData.currentDeviceId)
      } else {
        if (videoInputDevices.length > 1) {
          // 查找前置摄像头和后置摄像头
          const frontCamera = videoInputDevices.find(device => device.label.toLowerCase().includes("front") || device.label.toLowerCase().includes("selfie"))
          const backCamera = videoInputDevices.find(device => device.label.toLowerCase().includes("back"))

          if (this.scanTextData.isUsingBackCamera && frontCamera) {
            // 当前使用后置摄像头，切换到前置摄像头
            this.scanTextData.currentDeviceId = frontCamera.deviceId
            this.scanTextData.isUsingBackCamera = false
            this.scanTextData.isMirrored = true // 设置镜像效果
          } else if (backCamera) {
            // 当前使用前置摄像头，切换到后置摄像头
            this.scanTextData.currentDeviceId = backCamera.deviceId
            this.scanTextData.isUsingBackCamera = true
            this.scanTextData.isMirrored = false // 取消镜像效果
          }
          await this.decodeFromInputVideoFunc(this.scanTextData.currentDeviceId)
        } else {
          Toast(this.$t('append_field.camera_no_alternatives'))
        }
      }

    }
  },
}
</script>




<style scoped lang="scss">
.mirrored {
  transform: scaleX(-1);
}
/* 针对特定设备的调整 */
@media only screen and (max-width: 375px) and (max-height: 812px) {
  /* 适用于 iPhone X, XS, 11 Pro */
  .scan-tip, .scan-btn {
    z-index: 20; /* 提高 z-index 确保在前面 */
  }
}

@media only screen and (max-width: 390px) and (max-height: 844px) {
  /* 适用于 iPhone 12, 12 Pro */
  .scan-tip, .scan-btn {
    z-index: 20; /* 提高 z-index 确保在前面 */
  }
}

@media only screen and (max-width: 430px) and (max-height: 932px) {
  /* 适用于 iPhone 14 Pro */
  .scan-tip, .scan-btn {
    z-index: 20; /* 提高 z-index 确保在前面 */
  }
}

@media only screen and (max-width: 393px) and (max-height: 852px) {
  /* 适用于 iPhone 15 */
  .scan-tip, .scan-btn {
    z-index: 20; /* 提高 z-index 确保在前面 */
  }
}
body {
  margin: 0;
  background-color: rgb(133, 133, 133);
}
.qrcode {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;

  background-color: #000000; /* 确保有背景色 */
}
.scan-index-bar {
  background-image: linear-gradient(-45deg, #42a5ff, #59cfff);
}
.van-nav-bar__title {
  color: #fff !important;
}
.scan-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  height: 100%;
  width: 100vw;
  .scan-cacel {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 9;
    color: #fff;
    font-size: 35px;
  }
}
.scan-video {
  height: 100vh;
  width: 100vw;
  object-fit: cover;
  background-color: #000000; /* 视频加载前的背景色 */
}
.scan-img {
  width: 300px;
  height: 300px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -150px;
  z-index: 6;
  .scan-frame {
    width: 100%;
    height: 100%;
    position: relative;
    transition: all 0.3s ease;

    &.scan-success {
      .left-t,
      .right-t,
      .left-b,
      .right-b {
        border-color: #07c160; // 微信绿色
      }
      .cross-line {
        background: linear-gradient(
                to right,
                rgba(7, 193, 96, 0),
                #07c160,
                rgba(7, 193, 96, 0)
        );
      }
    }

    .left-t,
    .right-t,
    .left-b,
    .right-b {
      position: absolute;
      width: 80px;
      height: 80px;
      transition: border-color 0.3s ease;
    }
    .left-t {
      top: 0;
      left: 0;
      border-top: 2px solid #ffffff;
      border-left: 2px solid #ffffff;
    }
    .right-t {
      top: 0;
      right: 0;
      border-top: 2px solid #ffffff;
      border-right: 2px solid #ffffff;
    }

    .left-b {
      bottom: 0;
      left: 0;
      border-bottom: 2px solid #ffffff;
      border-left: 2px solid #ffffff;
    }

    .right-b {
      bottom: 0;
      right: 0;
      border-bottom: 2px solid #ffffff;
      border-right: 2px solid #ffffff;
    }
    .cross-line {
      width: 300px;
      height: 5px;
      background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0),
              #ffffff,
              rgba(255, 255, 255, 0)
      );
      position: absolute;
      top: 0;
      left: 0;
      animation: identifier_p 5s infinite;

      // 当扫码成功时，立即停止动画
      .scan-success & {
        animation: none !important;
        display: none !important;
      }
    }
    @keyframes identifier_p {
      0% {
        top: 0%;
      }
      50% {
        top: 100%;
      }
      100% {
        top: 0;
      }
    }
  }
}
.scan-tip {
  width: 100vw;
  text-align: center;
  margin-bottom: 10vh;
  color: #ffffff;
  font-size: 16px;
  position: fixed;
  top: 80px;
  left: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
}
.page-scan {
  overflow-y: hidden;
}
.back-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 100;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;

  &:active {
    background: rgba(0, 0, 0, 0.7);
  }
}

.scan-btn{
  width: 100vw;
  bottom: 50px;
  position: fixed;
  left: 0;
  text-align: center;
  z-index: 10;
  img{
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
  }
}

// 二维码中心圆点样式（类似微信）
.qr-code-dot {
  position: fixed;
  width: 20px;
  height: 20px;
  transform: translate(-50%, -50%);
  z-index: 100;
  pointer-events: none;
  animation: dotAppear 0.3s ease-out;

  .dot-inner {
    width: 100%;
    height: 100%;
    background-color: #07c160; // 微信绿色
    border-radius: 50%;
    box-shadow: 0 0 15px rgba(7, 193, 96, 0.8), 0 0 30px rgba(7, 193, 96, 0.4);
    animation: dotPulse 1.5s ease-in-out infinite;
  }
}

@keyframes dotAppear {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes dotPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(7, 193, 96, 0.8), 0 0 30px rgba(7, 193, 96, 0.4);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 20px rgba(7, 193, 96, 1), 0 0 40px rgba(7, 193, 96, 0.6);
  }
}

// 权限提示遮罩样式
.permission-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .permission-content {
    text-align: center;
    color: #fff;
    padding: 40px 20px;

    .permission-icon {
      font-size: 80px;
      margin-bottom: 20px;
      animation: pulse 2s ease-in-out infinite;
    }

    .permission-text {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .permission-desc {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      margin-top: 10px;
    }
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}
</style>
